"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Navigation = function (_a) {
    var step = _a.step, stepsCount = _a.stepsCount, setNextStep = _a.setNextStep, setPrevStep = _a.setPrevStep, closeDigest = _a.closeDigest;
    var t = (0, next_intl_1.useTranslations)('translation');
    var onClickHandle = (0, react_1.useCallback)(function () {
        if (step < stepsCount - 1) {
            setNextStep();
        }
        else
            closeDigest();
    }, [closeDigest, setNextStep, step, stepsCount]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(step > 0 ? styles_module_scss_1.default.notFirst : '') },
        step > 0 && (react_1.default.createElement("button", { className: styles_module_scss_1.default.backButton, onClick: setPrevStep }, t('back'))),
        react_1.default.createElement(ui_components_1.GradientOutlinedButton, { text: "upper", onClick: onClickHandle }, step < stepsCount - 1 ? t('next') : t('close'))));
};
exports.default = react_1.default.memo(Navigation);
